import { Alert, AlertDescription } from './ui/alert';

interface NoOpsSelectedProps {
  message?: string;
  /** Wrap in a full-page container (container mx-auto p-6) instead of space-y-6 */
  fullPage?: boolean;
  /** Extra classes appended to the wrapper div */
  className?: string;
}

export function NoOpsSelected({
  message = 'Selecione uma operação para continuar.',
  fullPage = false,
  className,
}: NoOpsSelectedProps) {
  const base = fullPage ? 'container mx-auto p-6' : 'space-y-6';
  const wrapper = className ? `${base} ${className}` : base;

  return (
    <div className={wrapper}>
      <Alert className="border-[hsl(214,32%,91%)] bg-white">
        <AlertDescription className="text-[hsl(215,16%,47%)]">
          {message}
        </AlertDescription>
      </Alert>
    </div>
  );
}
